import { render, staticRenderFns } from "./friendsTool.vue?vue&type=template&id=578504cf&scoped=true&"
import script from "./friendsTool.vue?vue&type=script&lang=js&"
export * from "./friendsTool.vue?vue&type=script&lang=js&"
import style0 from "./friendsTool.vue?vue&type=style&index=0&id=578504cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578504cf",
  null
  
)

component.options.__file = "friendsTool.vue"
export default component.exports